export default __webpack_public_path__ + "static/Custom-Report-4f8091c3c778eb1479fc86d287ff276e.png";